export type AppRole = 'Owner' | 'Technician'

export type NavItem = {
  label: string
  path: string
  roles: AppRole[]
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'لوحة التحكم', path: '/dashboard', roles: ['Owner'] },
  { label: 'الأجهزة', path: '/devices', roles: ['Owner', 'Technician'] },
  { label: 'زيارات الخدمة', path: '/service-visits', roles: ['Owner', 'Technician'] },
  { label: 'العملاء', path: '/customers', roles: ['Owner'] },
  { label: 'إعدادات الموقع', path: '/site-settings', roles: ['Owner'] },
  { label: 'الأخطاء', path: '/errors', roles: ['Owner'] },
  { label: 'المستخدمين', path: '/users', roles: ['Owner'] },
  { label: 'النسخ الاحتياطي', path: '/backup', roles: ['Owner'] },
]

export function navItemsForRole(role?: string | null): NavItem[] {
  const r = (role === 'Owner' ? 'Owner' : 'Technician') as AppRole
  return NAV_ITEMS.filter((item) => item.roles.includes(r))
}

export function isOwner(role?: string | null): boolean {
  return role === 'Owner'
}
